import logo from './logo.svg';
import './css/App.css';
import './css/colors_bt5.css'

import ReportPage from './pages/ReportPage';

export default function App() {
  // Redirect http to https
  if (window.location.hostname != "localhost") {
    if (window.location.protocol !== "https:") {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length
        )}`
      );
    }
  }

  return (
      <div>
        <ReportPage />
      </div>
  );
}


